/*
 ** EditView sodra define fields for editview reducer
 */
import { BSHOrder, Order, Layer, RecipeLayer, Recipe, IncomingPackage, PlanerSetup, BSHLayer, LineMaintenance, User } from '../../utils/models.js';
import { smartlamPlanerSetupCalculator, rigidplyInitCalculator, fournierChildCalculateValues } from '../../utils/modelFunctions/calculators.js';
import SmartyTab from '../../../app/components/CustomTableTabs/SmartyTab.js';
import CadworkTab from '../../../app/components/CustomTableTabs/CadworkTab.js';

const wiehag_config = {
  sortedOrderFields: [
    [
      [
        // { ...BSHOrder.fields.id },
        { ...BSHOrder.fields.identifier },
        { ...BSHOrder.fields.piecesPerLayer },
        { ...BSHOrder.fields.numberOfLayers },
        { ...BSHOrder.fields.lamellaLength },
        { ...BSHOrder.fields.lamellaThickness },
        { ...BSHOrder.fields.rawLamellaWidth },
        { ...BSHOrder.fields.sequence },
        { ...BSHOrder.fields.sortedOutputFieldsFournier, editable: true }
      ]
    ]
  ],
  orderFields: [
    [
      [{ ...Order.fields.projectNumber }, { ...Order.fields.projectName }, { ...Order.fields.masterpanel }, { ...Order.fields.nestingPanelNumber }, { ...Order.fields.panelMaterial }],
      [{ ...Order.fields.panelLength }, { ...Order.fields.panelWidth }, { ...Order.fields.panelThickness }]
    ],

    [[{ ...Order.fields.orderPicture }], [{ ...Order.fields.panelPicture }]]
  ],

  recipeOrderFields: [
    [
      [{ ...Recipe.fields.orderPicture }],
      [
        { ...Recipe.fields.identifier },
        { ...Order.fields.panelThickness },
        { ...Order.fields.oversize, halfsize: true, editable: true },
        { ...Order.fields.lenOversizeL, halfsize: true, editable: true },
        { ...Order.fields.oversizeWidth, halfsize: true },
        { ...Order.fields.lenOversizeC, halfsize: true }
      ]
    ]
  ],

  incomingPackageFields: [
    [
      [{ ...IncomingPackage.fields.cartId }, { ...IncomingPackage.fields.identifier }, { ...IncomingPackage.fields.quality }, { ...IncomingPackage.fields.woodType }],
      [{ ...IncomingPackage.fields.piecesPerLayer }, { ...IncomingPackage.fields.layers }, { ...IncomingPackage.fields.numBoards }],
      [{ ...IncomingPackage.fields.thickness }, { ...IncomingPackage.fields.width }, { ...IncomingPackage.fields.lamellaLength }]
    ]
  ],

  sortedPackageFields: [
    [
      [
        { ...IncomingPackage.fields.identifier },
        { ...IncomingPackage.fields.quality },
        { ...IncomingPackage.fields.piecesPerLayer },
        { ...IncomingPackage.fields.layers },
        { ...IncomingPackage.fields.woodType },
        { ...IncomingPackage.fields.thickness },
        { ...IncomingPackage.fields.width },
        { ...IncomingPackage.fields.lamellaLength },
        { ...IncomingPackage.fields.subPackages }
      ]
    ]
  ],

  bshorderFields: [
    [
      [
        { ...BSHOrder.fields.id, width: 2, editable: false },
        { ...BSHOrder.fields.orderNumber },
        { ...BSHOrder.fields.numberOfLayers, editable: false },
        { ...Layer.fields.woodType },
        { ...BSHOrder.fields.camberedRadius }
      ],
      [{ ...BSHOrder.fields.rawWidth }, { ...BSHOrder.fields.lamellaWidthNoValidation }],
      [{ ...BSHOrder.fields.rawThickness }, { ...BSHOrder.fields.lamellaThicknessNoValidation }],
      [{ ...BSHOrder.fields.assignedPress }, { ...BSHOrder.fields.manualEntry }, { ...BSHOrder.fields.iPressNumber }, { ...BSHOrder.fields.directionFournier }]
    ],
    [[{ ...BSHOrder.fields.shoePositions }]]
  ],
  bshLayerFields: [
    [
      [
        { ...Layer.fields.layerNo, width: 1.2, editable: false }, // positionInStack
        { ...Layer.fields.numOfLamellas, editable: false },
        { ...Layer.fields.useLKS, editable: true },
        { ...Layer.fields.headCutLength, editable: true },
        { ...Layer.fields.endCutLength, editable: true },
        { ...Layer.fields.splitY, editable: true }
      ],
      [
        { ...Layer.fields.woodType },
        { ...Layer.fields.rawThickness },
        { ...Layer.fields.lamellaPlannedThicknessNoValidation, width: 2, halfsize: true },
        { ...Layer.fields.lamellaWidthUS, width: 2, halfsize: true, editable: true },
        { ...Layer.fields.lamellaLengthFeet, width: 2 }
      ]
    ],
    // [[{ ...Layer.fields.lengthOffsetBSH }]],
    [[{ ...BSHLayer.fields.fournierSequence, width: 1, editable: true }]]

    /* [[{ ...BSHLayer.fields.beamSinglePictureGaishorn2, halfsize: false }]] */
  ],

  layerFields: [
    [
      [
        { ...Layer.fields.layerNo, width: 1.2, halfsize: true },
        { ...Layer.fields.quality, width: 1.2, halfsize: true },
        { ...Layer.fields.strengthString, width: 1.2, halfsize: true },
        { ...Layer.fields.woodType, width: 1.2, halfsize: true },
        // { ...Layer.fields.treatment, width: 1.2, halfsize: true },
        { ...Layer.fields.material, width: 1.2, halfsize: true },
        { ...Layer.fields.orientation, width: 1.2, halfsize: true },
        { ...Layer.fields.layerIdentifier, width: 1.2, halfsize: true }
      ],
      [
        { ...Layer.fields.lamellaThickness, width: 2, halfsize: true },
        { ...Layer.fields.lamellaPlannedThickness, width: 2, halfsize: true },
        { ...Layer.fields.lamellaWidthNoLimits, width: 2, halfsize: true },

        { ...Layer.fields.lamellaPlannedWidth, width: 2, halfsize: true },

        { ...Layer.fields.numOfLamellasEditable, width: 2 },
        { ...Layer.fields.numOfLamellasWood, width: 2 },
        { ...Layer.fields.numOfLamellasIns, width: 2 },
        { ...Layer.fields.fixedRecipeLayer, width: 1, halfsize: true },
        { ...Layer.fields.lengthoffsetWidth, width: 1, halfsize: true }
      ]
    ],

    [[{ ...Layer.fields.widthoffsetData }, { ...Layer.fields.notLamellaData }, { ...Layer.fields.lengthoffsetData }]],
    [[{ ...Layer.fields.layerPicture }]]
  ],

  recipeLayerFields: [
    [
      [
        // { ...Layer.fields.recipeLayerSelect },
        { ...RecipeLayer.fields.layerNo, width: 1.2 },
        { ...RecipeLayer.fields.woodType, width: 1.2 },
        { ...Layer.fields.orientation, width: 1.2, halfsize: true },
        { ...RecipeLayer.fields.rotation, width: 1.2, halfsize: true },
        { ...RecipeLayer.fields.quality, width: 1.2 }
      ],
      [
        { ...RecipeLayer.fields.lamellaPlannedThickness, width: 2 },
        { ...RecipeLayer.fields.lamellaThickness, width: 2 },
        { ...RecipeLayer.fields.lamellaPlannedWidth, width: 2 },
        { ...RecipeLayer.fields.minTakeAway, width: 2 }
      ],
      [
        { ...RecipeLayer.fields.hasGlue, width: 1.2 },
        { ...RecipeLayer.fields.whiteGlue, width: 1.2 }
      ]
    ],
    [[{ ...Layer.fields.recipewidthoffsetData }, { ...Layer.fields.recipenotLamellaData }, { ...Layer.fields.recipelengthoffsetData }]]
  ],

  lineMaintenanceFields: [
    [
      [
        { ...LineMaintenance.fields.identifier },
        { ...LineMaintenance.fields.area },
        { ...LineMaintenance.fields.machine },
        { ...LineMaintenance.fields.extraData },
        { ...LineMaintenance.fields.assignedCycle }
      ],
      [{ ...LineMaintenance.fields.assignUser }, { ...LineMaintenance.fields.startingDay }]
    ]
  ],

  orderWithRecipeFields: [
    [
      [{ ...Order.fields.recipeSelect }, { ...Recipe.fields.getOrderWithRecipeImage }],
      [{ ...Recipe.fields.identifier }, { ...Order.fields.orderNumber }, { ...Order.fields.panelWidth }, { ...Order.fields.panelLength }, { ...Order.fields.panelThickness }]
    ]
  ],

  orderLayerRecipeFields: [
    [
      [{ ...Recipe.fields.getOrderWithRecipeImage }],
      [{ ...Recipe.fields.identifier }, { ...Order.fields.orderNumber }, { ...Order.fields.panelWidth }, { ...Order.fields.panelLength }, { ...Order.fields.panelThickness }]
    ]
  ],

  layerWithRecipeFields: [[[{ ...Layer.fields.recipeLayerSelect }, { ...Layer.fields.getLayerWithRecipeImage }]]],

  planerSetupFields: [
    [
      [
        { ...PlanerSetup.fields.rawWidth },
        { ...PlanerSetup.fields.rawThickness },
        { ...PlanerSetup.fields.lamellaPlannedThickness },
        { ...PlanerSetup.fields.W1Takeaway },
        { ...PlanerSetup.fields.W3Takeaway },
        { ...PlanerSetup.fields.quality },
        { ...PlanerSetup.fields.posWhiteGlue },
        { ...PlanerSetup.fields.posHotmelt },
        { ...PlanerSetup.fields.linesOfWhiteGlue },
        { ...PlanerSetup.fields.linesOfHotmelt }
      ],
      [{ ...PlanerSetup.fields.splitWood }, { ...PlanerSetup.fields.turningZinc }, { ...PlanerSetup.fields.turningAfterPress }],
      [{ ...PlanerSetup.fields.turningBeforePress }, { ...PlanerSetup.fields.turningEverySecond }, { ...PlanerSetup.fields.turningEveryFirst }]
    ]
  ],
  userFields: [
    [
      [
        { ...User.fields.username },
        { ...User.fields.role },
        { ...User.fields.color },
        { ...User.fields.newPassword },
        { ...User.fields.confirmPassword },
        { ...User.fields.vncClients },
        { ...User.fields.rfid }
      ]
    ]
  ],
  calculatorsConfig: {
    planerSetup: {
      modelCalculator: smartlamPlanerSetupCalculator
    },
    bshorder: {
      childCalculator: fournierChildCalculateValues,
      modelCalculatorInit: rigidplyInitCalculator
    }
  },
  otherOptions: {
    bshorder: {
      extraTabs: [
        {
          key: 'fournier-hyperPressCurvedBeam',
          label: 'Beam Preview',
          component: CadworkTab,
          visibleWhen: (item) => item?.assignedPress === 'hyper' || Number(item?.assignedPress) === 1,
          props: {
            showPrepareButton: false,
            sequenceFields: ['lamellas'],
            pressureField: 'directionFournier',
            hideMissingLslWarning: true
          }
        },
        {
          key: 'fournier-smarty',
          label: 'Smarty',
          component: SmartyTab,
          countEndpoint: '/api/v1/orders/bsh/{id}/smarty_images/'
        }
      ]
    }
  }
};

export default wiehag_config;
